

























import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { getUsersApprovalChartData } from '@/services/dashboard';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy'
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages,
  },
})
export default class ApprovalPrescriptionCharts extends BaseComponent {
  @Prop()
  public dateFrom: string;
  @Prop()
  public dateTo: string;
  @Prop()
  public idsBusinessUnits: number[];

  loading = false;
  error = false;
  private show: boolean = false;
  private chartData: any[] = [];

  private chartOptions = {
    //curveType: 'function',
    backgroundColor: 'transparent',
    /*width: 500,*/
    height: 300,
    chartArea: { left: '150', top: '20', right: '100', bottom: '130' },
    legend: { position: 'none' },

    hAxis: {
      slantedText: true,
      textStyle: {
        fontSize: 13,
      },
    } /*,
    vAxis: {
      title: null,
      minValue: 0,
    },*/,
  };

  private execBehaviorSub$: BehaviorSubject<any> = new BehaviorSubject(null);

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(300),
        tap(() => {
          this.loading = true;
        }),
        switchMap((filter) => {
          return getUsersApprovalChartData(filter);
        }),
      )
      .subscribe(
        (res) => {
          this.loading = false;
          this.chartData.push(['Usuário', 'Aprovações', { role: 'style' }, this.columnAnnotation]);
          res.forEach((i) => {
            this.chartData.push([i.id, i.valor, `color: ${this.barColor}`, i.valor]);
          });
        },
        (error) => {
          this.loading = false;
          this.error = true;
        },
      );

    this.prepareLoad();
    setTimeout(() => {
      this.show = true;
    }, 100);
  }

  load() {
    this.loadByType();
  }

  columnAnnotation = { calc: 'stringify', sourceColumn: 1, type: 'string', role: 'annotation' };

  loadByType() {
    this.chartData.splice(0, this.chartData.length);
    let filtro = this.buildFiltro();
    this.execBehaviorSub$.next(filtro);
  }

  buildFiltro() {
    let filtro: any = {};
    filtro.dataDe = this.dateFrom ? dateFormat(this.dateFrom, 'US') : null;
    filtro.dataAte = this.dateTo ? dateFormat(this.dateTo, 'US') : null;
    filtro.idsEmpresas = this.idsBusinessUnits;

    return filtro;
  }

  @Watch('dateFrom')
  @Watch('dateTo')
  @Watch('idsBusinessUnits')
  public onChangeDates() {
    this.prepareLoad();
  }

  timeoutDatesChange = null;
  public prepareLoad() {
    clearTimeout(this.timeoutDatesChange);
    this.timeoutDatesChange = setTimeout(() => {
      this.load();
    }, 100);
  }
}
